<h2 mat-dialog-title>{{ 'kurzantrag.title' | translate }}</h2>
<mat-dialog-content>
  @if (userData; as user) {
    <dl cdkTrapFocus class="user-data">
      <dt class="user-data__title">{{ 'kurzantrag.vorname' | translate }} {{ 'kurzantrag.name' | translate }}</dt>
      <dd class="user-data__description">{{ user.vorname }} {{ user.nachname }}</dd>
      <dt class="user-data__title">{{ 'kurzantrag.birthday' | translate }}</dt>
      <dd class="user-data__description">{{ user.gebdat }}</dd>
      <dt class="user-data__title">{{ 'kurzantrag.personalnumber' | translate }}</dt>
      <dd class="user-data__description">{{ user.personalnummer }}</dd>
      @if (user.email) {
        <dt class="user-data__title">{{ 'kurzantrag.email' | translate }}</dt>
        <dd class="user-data__description">{{ user.email }}</dd>
      }
    </dl>
  }
  <mat-divider />
  <form (ngSubmit)="submit()" [formGroup]="form" class="mat-form" tabindex="1">
    <form-base (modelChanges)="updateModel($event)" [formElements]="fields" [form]="form" [model]="model" />
  </form>
  <p>
    <a routerLink="/info/datenschutz" target="_blank">{{ 'kurzantrag.privacy' | translate }}</a>
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button color="primary" mat-button mat-dialog-close type="button">
    {{ 'kurzantrag.declineAndCloseModal' | translate }}
  </button>
  <button (click)="submit()" [disabled]="form.pristine || form.invalid" color="primary" mat-raised-button type="button">
    {{ 'kurzantrag.acceptAndCloseModal' | translate }}
  </button>
</mat-dialog-actions>
